import React from "react";

const Logo = ({ width = "118", height = "35", className = "" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 118 35"
      fill="none"
      className={className}
    >
      <path
        d="M39.3174 20.5249H35.6283C35.4753 20.5249 35.3507 20.6495 35.3507 20.8025V27.6682C35.3507 27.8729 35.1852 28.0384 34.9805 28.0384H31.4053C31.2007 28.0384 31.0352 27.8729 31.0352 27.6682V6.52487C31.0352 6.322 31.2007 6.15649 31.4053 6.15649H39.3174C43.4977 6.15649 46.8967 8.833 46.8967 13.3247C46.8967 17.8164 43.4977 20.5249 39.3174 20.5249ZM35.3525 16.3909C35.3525 16.544 35.477 16.6685 35.6301 16.6685H39.1501C41.3906 16.6685 42.5812 15.2538 42.5812 13.3229C42.5812 11.3921 41.3924 10.0111 39.1501 10.0111H35.6301C35.477 10.0111 35.3525 10.1357 35.3525 10.2887V16.3909Z"
        fill="black"
      />
      <path
        d="M52.4161 12.7533V13.5684C52.4161 13.7054 52.5816 13.7677 52.6741 13.668C53.4678 12.8014 54.9485 12.2515 56.5341 12.2515H57.52C57.7246 12.2515 57.8901 12.417 57.8901 12.6216V15.8373C57.8901 16.042 57.7246 16.2075 57.52 16.2075H56.5003C53.8309 16.2075 52.4143 17.9212 52.4143 20.4251V27.6681C52.4143 27.8727 52.2488 28.0382 52.0442 28.0382H48.6309C48.4262 28.0382 48.2607 27.8727 48.2607 27.6681V12.7533C48.2607 12.5487 48.4262 12.3832 48.6309 12.3832H52.0442C52.2488 12.3832 52.4143 12.5487 52.4143 12.7533H52.4161Z"
        fill="black"
      />
      <path
        d="M75.1107 20.2274C75.1107 24.9397 71.4536 28.4651 66.6095 28.4651C61.7655 28.4651 58.1084 24.9397 58.1084 20.2274C58.1084 15.515 61.7655 11.9558 66.6095 11.9558C71.4536 11.9558 75.1107 15.4812 75.1107 20.2274ZM62.2602 20.2274C62.2602 22.8309 64.1377 24.6425 66.6095 24.6425C69.0814 24.6425 70.9589 22.8309 70.9589 20.2274C70.9589 17.6238 69.0796 15.7784 66.6095 15.7784C64.1395 15.7784 62.2602 17.59 62.2602 20.2274Z"
        fill="black"
      />
      <path
        d="M85.4911 28.4653C83.9037 28.4653 82.2878 27.9742 81.2147 27.0933C81.0937 26.9936 80.9104 27.0755 80.9104 27.2339V34.3896C80.9104 34.5943 80.7449 34.7598 80.5403 34.7598H77.127C76.9223 34.7598 76.7568 34.5943 76.7568 34.3896V12.7533C76.7568 12.5487 76.9223 12.3832 77.127 12.3832H80.5403C80.7449 12.3832 80.9104 12.5487 80.9104 12.7533V13.2356C80.9104 13.3619 81.0563 13.4296 81.1524 13.3477C82.2238 12.4365 83.8717 11.9561 85.4911 11.9561C90.5327 11.9561 93.4993 15.9103 93.4993 20.1938C93.4993 24.4773 90.5327 28.4653 85.4911 28.4653ZM85.1619 15.7786C82.9534 15.7786 80.7467 17.229 80.7467 20.1938C80.7467 23.1586 82.9552 24.6428 85.1619 24.6428C87.6337 24.6428 89.3475 22.5998 89.3475 20.1938C89.3475 17.7878 87.6337 15.7786 85.1619 15.7786Z"
        fill="black"
      />
      <path
        d="M110.395 23.2918C110.664 23.2918 110.846 23.5694 110.733 23.8132C109.409 26.6748 106.413 28.4651 103.24 28.4651C98.3617 28.4651 94.7705 24.9397 94.7705 20.1935C94.7705 15.4474 98.23 11.9558 103.074 11.9558C107.918 11.9558 111.214 15.515 111.214 20.1277C111.214 20.537 111.214 20.8662 111.184 21.2399C111.168 21.4304 111.006 21.5781 110.815 21.5781H99.4526C99.2658 21.5781 99.1287 21.7614 99.1875 21.9375C99.7374 23.6068 101.33 24.6425 103.24 24.6425C104.492 24.6425 105.626 24.2848 106.359 23.4288C106.432 23.3434 106.535 23.2918 106.646 23.2918H110.395ZM106.462 18.4798C106.64 18.4798 106.776 18.3125 106.733 18.1399C106.336 16.524 104.864 15.5132 103.076 15.5132C101.287 15.5132 99.6822 16.5489 99.2586 18.1363C99.2124 18.3107 99.3494 18.4798 99.5292 18.4798H106.462Z"
        fill="black"
      />
      <path
        d="M117.248 6.36161V27.6687C117.248 27.8733 117.083 28.0388 116.878 28.0388H113.465C113.26 28.0388 113.095 27.8733 113.095 27.6687V6.36161C113.095 6.15696 113.26 5.99146 113.465 5.99146H116.878C117.083 5.99146 117.248 6.15696 117.248 6.36161Z"
        fill="black"
      />
      <g clipPath="url(#clip0_705_1101)">
        <path
          d="M5.79121 1.59644C5.79121 1.59644 4.98389 2.19345 4.38009 2.79046C4.19013 2.95328 4.21048 3.12289 4.22405 3.36712C4.28511 4.18802 4.44115 6.01298 5.68267 7.35626C6.9174 8.69954 8.5117 8.51636 8.5117 8.51636L11.9038 7.7701L5.79121 1.59644Z"
          fill="black"
          stroke="black"
          strokeWidth="0.797439"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.446289 18.5635C0.446289 24.0113 5.04602 28.4278 10.7244 28.4278C16.4029 28.4278 21.0026 24.0113 21.0026 18.5635C21.0026 13.1158 16.4029 8.69922 10.7244 8.69922C5.04602 8.69922 0.446289 13.1158 0.446289 18.5635ZM6.17899 18.5635C6.17899 21.1008 8.32282 23.1564 10.9687 23.1564C13.6145 23.1564 15.7584 21.1008 15.7584 18.5635C15.7584 16.0262 13.6145 13.9706 10.9687 13.9706C8.32282 13.9706 6.17899 16.0262 6.17899 18.5635Z"
          fill="black"
          stroke="black"
          strokeWidth="0.797439"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.18945 18.1496C2.18945 23.8687 6.8231 28.5024 12.5422 28.5024C18.2614 28.5024 22.895 23.8687 22.895 18.1496C22.895 12.4305 18.2614 7.79688 12.5422 7.79688C6.8231 7.79688 2.18945 12.4305 2.18945 18.1496ZM7.71863 18.1496C7.71863 20.8158 9.87602 22.9732 12.5422 22.9732C15.2085 22.9732 17.3658 20.8158 17.3658 18.1496C17.3658 15.4834 15.2085 13.326 12.5422 13.326C9.87602 13.326 7.71863 15.4834 7.71863 18.1496Z"
          fill="#FFC120"
          stroke="black"
          strokeWidth="0.797439"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.85059 11.2297C5.80445 9.56077 7.62264 8.59741 10.3635 8.02075"
          stroke="black"
          strokeWidth="0.797439"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M7.44727 27.9124C9.95744 28.6858 12.237 28.7943 14.7064 28.2787"
          stroke="black"
          strokeWidth="0.797439"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M11.9067 7.76998C12.0424 7.74284 12.1645 7.66821 12.2392 7.5461C12.8023 6.63701 12.5784 4.7035 11.3776 3.60445C10.0275 2.41721 9.02342 2.6818 6.60822 1.53526C5.98407 1.23675 5.48203 1.63024 5.57701 2.38329C5.67199 3.13634 6.29615 5.99251 8.06684 7.17975C9.32871 8.02099 11.2622 7.91245 11.9067 7.77676V7.76998Z"
          fill="#8BC95A"
          stroke="black"
          strokeWidth="0.797439"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_705_1101">
          <rect
            width="23.2767"
            height="28"
            fill="white"
            transform="translate(0 0.971924)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Logo;
